import { apiClient } from "./apiClient";

export interface BordeiroKanbanItem {
  bordaNome: string;
  nome: string;
  total: number;
  feitas: number;
  pendentes: number;
  detalhesPorTamanho: {
    tamanho: string;
    total: number;
    feitas: number;
    pendentes: number;
  }[];
  referenciasPendentes: {
    bordaPreparoId: number;
    orderId: number | null;
    displayId: number | null;
    tamanho: string;
    observation: string | null;
    assignedToUserNome: string | null;
    filaSalgadaId: number | null;
    filaDoceId: number | null;
    filaSalaoSalgadaId: number | null;
    filaSalaoDoceId: number | null;
  }[];
}

export interface PaozinhoKanbanItem {
  saborChave: string;
  nome: string;
  total: number;
  feitas: number;
  pendentes: number;
  referenciasPendentes: {
    paozinhoPreparoId: number;
    orderId: number | null;
    displayId: number | null;
    observation: string | null;
    origem: "cardapio" | "salao";
    salaoMesaId: string | null;
    salaoComandaId: string | null;
    salaoIdentificador: string | null;
  }[];
}

export interface PaozinhosResumoBlock {
  totalPendentes: number;
  totalFeitas: number;
  itens: PaozinhoKanbanItem[];
}

export interface EstoqueCriticoItem {
  bordaNome: string;
  tamanho: string;
  consumido: number;
  planejado: number;
  percentual: number;
}

export interface BordeiroResumoResponse {
  dataReferencia: string;
  totalPendentes: number;
  totalFeitas: number;
  itens: BordeiroKanbanItem[];
  bordasEmFalta: string[];
  estoqueCritico?: EstoqueCriticoItem[];
  paozinhos: PaozinhosResumoBlock;
}

export interface BordeiroDashboardResumoResponse {
  bordas: {
    totalProduzidas: number;
    tempoMedioSegundos: number | null;
    pendentes: number;
  };
  paozinhos: {
    totalProduzidos: number;
    tempoMedioSegundos: number | null;
    pendentes: number;
  };
}

export const bordeiroService = {
  getResumo: async (lojaId?: number): Promise<BordeiroResumoResponse> => {
    const query = lojaId ? `?lojaId=${lojaId}` : "";
    return apiClient.get(`/bordeiro/resumo${query}`);
  },

  getResumoDashboard: async (filters: {
    dataInicio: string;
    dataFim: string;
    lojaId?: number;
  }): Promise<BordeiroDashboardResumoResponse> => {
    const params = new URLSearchParams();
    params.set("dataInicio", filters.dataInicio);
    params.set("dataFim", filters.dataFim);
    if (filters.lojaId != null) {
      params.set("lojaId", String(filters.lojaId));
    }
    return apiClient.get(`/bordeiro/resumo-dashboard?${params.toString()}`);
  },

  finalizarPaozinho: async (
    paozinhoPreparoId: number
  ): Promise<BordeiroResumoResponse> => {
    return apiClient.post("/bordeiro/finalizar-paozinho", {
      paozinhoPreparoId,
    });
  },

  finalizarBorda: async (
    bordaNome: string,
    quantidade = 1,
    referencia?: {
      orderId: number | null;
      displayId: number | null;
      tamanho: string | null;
      filaSalgadaId: number | null;
      filaDoceId: number | null;
      filaSalaoSalgadaId: number | null;
      filaSalaoDoceId: number | null;
    },
    lojaId?: number
  ): Promise<BordeiroResumoResponse> => {
    return apiClient.post("/bordeiro/finalizar", {
      bordaNome,
      quantidade,
      orderId: referencia?.orderId ?? null,
      displayId: referencia?.displayId ?? null,
      tamanho: referencia?.tamanho ?? null,
      filaSalgadaId: referencia?.filaSalgadaId ?? null,
      filaDoceId: referencia?.filaDoceId ?? null,
      filaSalaoSalgadaId: referencia?.filaSalaoSalgadaId ?? null,
      filaSalaoDoceId: referencia?.filaSalaoDoceId ?? null,
      lojaId,
    });
  },
};
